// WebsiteIndividual.js
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import "./Website_Individual.css";
export const WebsiteIndividual = () => {
  const { websiteId } = useParams();
  console.log(websiteId);
  const [website, setWebsite] = useState(null);
  const [imgSrc, setImgSrc] = useState(null);
  const [imageAllowed, setImageAllowed] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    async function getInfo() {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/verify`,
          {
            withCredentials: true,
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );
        if (data.message === "Please login first") {
          navigate("/adminLogin");
        }
      } catch (error) {
        console.log(error);
      }
    }
    getInfo();
  }, []);
  const getWebsite = async () => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/blogs/hero/indi/${websiteId}`,
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );
      if (
        data.key === "Equitable" ||
        data.key === "Trust" ||
        data.key === "Relatability" ||
        data.key === "Identity"
      ) {
        setImageAllowed(true);
      } else {
        setImageAllowed(false);
      }
      setImgSrc("https://picsum.photos/300/200"); //set Image source
      setWebsite(data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getWebsite();
  }, []);

  if (!website) {
    return <div>Loading...</div>;
  }

  return (
    <div className="container">
      
      <h2 className="title">{website.page}</h2>
      <p>
        <strong>Key:</strong> {website.key}
      </p>
      <div>{website.value}</div>

      {/* Add more details based on your website data */}
    </div>
  );
};
